import { initSection } from '../../core/shopify/init-section/index.js';
const NAMESPACE = '.js-split-background';
const GAP = 60 // px of breathing room on each side of the image
;
initSection(NAMESPACE, (section)=>{
    const upper = section.querySelector('.js-split-upper');
    const lower = section.querySelector('.js-split-lower');
    const imageWrap = section.querySelector('.js-split-image-wrap');
    if (!upper || !imageWrap) return {
        unload: null
    };
    const positionImage = ()=>{
        const halfHeight = imageWrap.offsetHeight / 2;
        // Set padding so there is always exactly GAP pixels between the image
        // edge and the surrounding content, regardless of viewport width.
        upper.style.paddingBottom = `${halfHeight + GAP}px`;
        if (lower) lower.style.paddingTop = `${halfHeight + GAP}px`;
        // Position the image after padding is applied so offsetHeight is stable.
        imageWrap.style.top = `${upper.offsetHeight}px`;
    };
    positionImage();
    window.addEventListener('resize', positionImage);
    // Re-run once images have their intrinsic dimensions
    imageWrap.querySelectorAll('img').forEach((img)=>{
        if (!img.complete) img.addEventListener('load', positionImage);
    });
    return {
        unload: ()=>{
            window.removeEventListener('resize', positionImage);
            upper.style.paddingBottom = '';
            if (lower) lower.style.paddingTop = '';
            imageWrap.style.top = '';
        }
    };
});
